import axiosInstance from "../../axiosConfig";

let inFlightRequests = new Map();

export const apiRequest = async ({
  method = "get",
  apiEndpoint = "",
  payload = { body: null, queries: null },
  contentType = "application/json",
  uploadProgress = () => {},
  downloadProgress = () => {},
  customHeader = {},
}) => {
  try {
    const requestKey = `${method.toLowerCase()}-${apiEndpoint}-${JSON.stringify(
      payload
    )}`;

    if (inFlightRequests.has(requestKey)) {
      return inFlightRequests.get(requestKey);
    }

    const headers = {
      customHeader: JSON.stringify({
        "Content-Type": contentType,
        Accept: contentType,
        ...(typeof customHeader === "object" &&
          Object.keys(customHeader)?.length > 0 &&
          customHeader),
      }),
    };
    const isGet = method.toLowerCase() === "get";
    const isDeleteWithBody = method.toLowerCase() === "delete" && payload?.body;

    const requestPromise = axiosInstance[method.toLowerCase()](
      `${apiEndpoint}${
        payload?.queries
          ? "?" + new URLSearchParams(payload.queries).toString()
          : ""
      }`,
      isGet
        ? {
            headers,
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              uploadProgress(percentCompleted);
            },
            onDownloadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              downloadProgress(percentCompleted);
            },
          }
        : isDeleteWithBody
        ? {
            data: payload.body,
            headers,
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              uploadProgress(percentCompleted);
            },
            onDownloadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              downloadProgress(percentCompleted);
            },
          }
        : payload?.body,
      !isGet && {
        headers,
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          uploadProgress(percentCompleted);
        },
        onDownloadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          downloadProgress(percentCompleted);
        },
      }
    );

    inFlightRequests.set(requestKey, requestPromise);

    const res = await requestPromise.finally(() => {
      inFlightRequests.delete(requestKey);
    });
    return res;
  } catch (error) {
    return error?.response;
  }
};
